import React from "react";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1 className="text-4xl font-bold mb-4">{t("contact-us.title")}</h1>
      <div className="container mx-auto">
        <div className="max-w-md mx-auto">
          <p className="text-gray-800 text-center mb-4">
            We value your feedback! If you have any suggestions or questions,
            please reach out to us.
          </p>
          <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            <h2 className="text-gray-800 text-lg font-semibold mb-4">
              Send us a message
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              You can email us at{" "}
              <a
                href="mailto:promptlydone.inquery@gmail.com"
                className="text-blue-500"
              >
                promptlydone.inquery@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
